// extracted by mini-css-extract-plugin
module.exports = {"container":"BulletList_container__VJmBN","text":"BulletList_text__RuKpR","bullets_wrapper":"BulletList_bullets_wrapper__VmpYH"};